/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_Text_OpacityInputs */



/**
* | output |
* | --- |
* | "Text Opacity" |
*
* @param {Options_Watermark_Text_OpacityInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_text_opacity = /** @type {((inputs?: Options_Watermark_Text_OpacityInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Text_OpacityInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Opacité du texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Textdeckkraft")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opacità del testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Непрозрачность текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opacidad del texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本不透明度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストの不透明度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट अपारदर्शिता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opacidade do texto")
	return /** @type {LocalizedString} */ ("Text Opacity")
});